import { render, staticRenderFns } from "./globalWebTag.vue?vue&type=template&id=16f8e768"
import script from "./globalWebTag.vue?vue&type=script&lang=js"
export * from "./globalWebTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports